/**
 * @generated SignedSource<<6eb1fa95a97dff9c1d804c9ed920f281>>
 * @relayHash ecf40a05bf9cddbcde50438c8555a6b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8360c92d3ea760534512f76bdd4203a3fe513dfe84b32ad38d66251f87c7a620

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8360c92d3ea760534512f76bdd4203a3fe513dfe84b32ad38d66251f87c7a620",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
